import { call, put, takeEvery } from 'redux-saga/effects';

//import { useNavigate } from "react-router-dom";

// Register redux actions
import { registerCustomerErrorAction, registerCustomerSuccessAction } from '~/store/register/actions';

// API calls
import {
	api_facebookRegisterCustomer,
	api_googleRegisterCustomer,
	api_registerCustomer,
	api_registerStoreCustomer
} from '~/backend/api_calls';

function* registerCustomer(action) {
	try {
		console.debug(action);
		const response = yield call(api_registerCustomer, action.args);
		console.debug('Register response: ' + response);

		yield put(registerCustomerSuccessAction('Registration completed'));
	} catch (error) {
		console.debug('error');
		yield put(registerCustomerErrorAction(error));
	}
}

function* googleRegisterCustomer(action) {
	try {
		const response = yield call(api_googleRegisterCustomer, action.args);
		console.debug('Register response: ' + response);

		yield put(registerCustomerSuccessAction('Google Registration completed'));
	} catch (error) {
		yield put(registerCustomerErrorAction(error));
	}
}

function* facebookRegisterCustomer(action) {
	try {
		const response = yield call(api_facebookRegisterCustomer, action.args);
		console.debug('Register response: ' + response);

		yield put(registerCustomerSuccessAction('Facebook Registration completed'));
	} catch (error) {
		yield put(registerCustomerErrorAction(error));
	}
}

function* registerStoreCustomer(action) {
	try {
		console.debug(action);
		const response = yield call(api_registerStoreCustomer, action.args);
		console.debug('Register store (plugin) response: ' + response);

		yield put(registerCustomerSuccessAction('Registration completed'));
	} catch (error) {
		yield put(registerCustomerErrorAction(error));
	}
}

function* registerSaga() {
	yield takeEvery('register-customer', registerCustomer);
	yield takeEvery('google-register-customer', googleRegisterCustomer);
	yield takeEvery('facebook-register-customer', facebookRegisterCustomer);
	yield takeEvery('register-store-customer', registerStoreCustomer);
}

export default registerSaga;
